module.exports = __webpack_public_path__ + "img/store_appaga.4bb41f63.jpg";